import { displayMessage } from '../helpers/messages'

export const EAlertTypes = {
    // INFO: { param: 'info', defaultTitle: displayMessage('Atenção') },
    SUCCESS: { param: 'success', defaultTitle: displayMessage('SUCCESS') },
    WARNING: { param: 'warning', defaultTitle: displayMessage('WARNING') },
    ERROR: { param: 'error', defaultTitle: displayMessage('ERROR') },
}
